import { NextSeo } from "next-seo";
import PropTypes from "prop-types";
import { mediaPropTypes } from "utils/types";

const Seo = ({ metadata }) => {
  // Prevent errors if no metadata was set
  if (!metadata) return null;

  return (
    <NextSeo
      title={metadata.metaTitle}
      description={metadata.metaDescription}
      canonical={metadata.canonicalURL}
      robotsProps={metadata.metaRobots}
      additionalMetaTags={[
        {
          property: "keywords",
          content: metadata.keywords,
        },
        {
          name: "application-name",
          content: "Onmo",
        },
      ]}
      openGraph={{
        // Title and description are mandatory
        title: metadata.metaTitle,
        description: metadata.metaDescription,
        images: [
          {
            width: metadata.metaImage.data.attributes.width,
            height: metadata.metaImage.data.attributes.height,
            url: metadata.metaImage.data.attributes.url,
            alt: metadata.metaImage.data.attributes.alternativeText,
            type: metadata.metaImage.data.attributes.mime,
          },
        ],
        // ...(metadata.metaImage && {
        //   images: [
        //     {
        //       url: metadata.metaImage.data.attributes.url,
        //       width: 500,
        //       height: 500,
        //       alt: metadata.metaImage.data.attributes.alternativeText,
        //     },
        //   ]
        // }),
      }}
      // Only included Twitter data if we have it
      twitter={{
        title: metadata.metaTitle,
        description: metadata.metaDescription,
        cardType: "summary",
      }}
    />
  );
};

Seo.propTypes = {
  metadata: PropTypes.shape({
    metaTitle: PropTypes.string.isRequired,
    metaDescription: PropTypes.string.isRequired,
    shareImage: mediaPropTypes,
    twitterCardType: PropTypes.string,
    twitterUsername: PropTypes.string,
  }),
};

export default Seo;
